import React from "react";
import "./styles.scss";
import { renderRichText } from "gatsby-source-contentful/rich-text";
import {
  Button, ButtonColour, ButtonSize, Typography,
  useWindowSize,
  MQ_EXTRA_WIDE_V2
} from "@trussle/external-components";
import { IContentfulHeroProps } from "../../types/IHero";
import { PanelWrapper } from "../PanelWrapper";
import { trackEvent } from "../../helpers/analytics";
import { Checklist } from "../Checklist";
import MipImg from "./mip-browser.png";
import BrowserSVG from "../../static/browser-orange.svg";
import TrustBox from "../TrustBox";

const HeroMIP: React.FC<IContentfulHeroProps> = ({
  heading1,
  firstCta,
  trustpilotIconLink,
  bullets,
}) => {
  const { width } = useWindowSize();

  const onButtonClick = async (url: string) => {
    await trackEvent("Get started clicked", {
      module: "HeroMIP",
      element_type: "Button",
      section: "Megabutton",
    });
    window.location.assign(url);
  };

  const promptText = (
    <div className="heroMIP__prompt-container">
      <img width={40} height={40} src={BrowserSVG} alt="browser icon" className="" loading="lazy" />
      <div className="heroMIP__prompt-text">
        <span className="heroMIP__prompt-text-highlight">Complete the form on our website</span>
        {" "}
        in just a few minutes to get started
      </div>
    </div>
  )

  return (
    <div className="heroMIP__container">
      <PanelWrapper>
        <div className="heroMIP">
          <div className="heroMIP__content left">
            {heading1
          && <Typography variant="h1" component="h1" classes="heroMIP__heading">{renderRichText(heading1)}</Typography>}
            <Checklist bullets={bullets} />
            { width && width <= MQ_EXTRA_WIDE_V2 && promptText}
            {firstCta && (
              <Button
                size={ButtonSize.Large}
                colour={ButtonColour.DarkYellow}
                onClick={() => onButtonClick(firstCta.url)}
                classOverrides={{ button: "heroMIP__cta__mobile" }}
                fixed={false}
              >
                {firstCta?.title}
              </Button>
            )}
            <MaybeLink
              label="trustpilot"
              testId="hero-inlineimg1-link"
              url={trustpilotIconLink?.url}
            >
              <TrustBox className="heroff2-trustbox" />
            </MaybeLink>
          </div>
          <div className="heroMIP__content right">
            <div className="heroMIP__image__container">
              <img src={MipImg} alt="Mip icon" className="heroMIP__image" loading="lazy" />
              {firstCta && (
              <Button
                size={ButtonSize.Large}
                colour={ButtonColour.DarkYellow}
                onClick={() => onButtonClick(firstCta.url)}
                classOverrides={{ button: "heroMIP__cta" }}
                fixed={false}
              >
                {firstCta?.title}
              </Button>
              )}
            </div>
            { width && width > MQ_EXTRA_WIDE_V2 && promptText}
          </div>
        </div>
      </PanelWrapper>
    </div>
  );
};

type IMaybeLinkProps = {
  label: string;
  testId: string;
  children?: React.ReactNode;
  url?: string;
};
export function MaybeLink({
  label, testId, url, children,
}: IMaybeLinkProps) {
  if (url) {
    return (
      <a className={`heroMIP__${label}`} data-testid={testId} href={url}>
        {children}
      </a>
    );
  }
  return (
    <div className={`heroMIP__${label}`} data-testid={testId} aria-label="Hero trustpilot">
      {children}
    </div>
  );
}

export default HeroMIP;
